var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-checkbox',{attrs:{"shape":_vm.shape,"checked-color":_vm.checkedColor},on:{"change":_vm.handelChange},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }